<!--
 * @Author: zyy
 * @Date: 2022-11-17 11:32:42
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-18 11:20:11
 * @Description: default
-->
<template>
    <div>
        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmmodal"
            destroy-on-close centered :width="1000">
            <div class="input-box">
                <input type="text" placeholder="输入关键字过滤" v-model="keyword" @change="onChange">
            </div>
            <div>
                <a-tree v-model="checkedKeys" checkable :autoExpandParent="autoExpandParent"
                :tree-data="treeData" @check="onCheck" @expand="onExpand" :expanded-keys="expandedKeys"
                    :defaultExpandedKeys="['100000']">

                    <template slot="title" slot-scope="{ title }">
                        <span v-if="title.indexOf(keyword) > -1">
                            {{ title.substr(0, title.indexOf(keyword)) }}
                            <span style="color: #f50">{{ keyword }}</span>
                            {{ title.substr(title.indexOf(keyword) + keyword.length) }}
                        </span>
                        <span v-else>{{ title }}</span>
                    </template>
                </a-tree>
            </div>
        </a-modal>
    </div>

</template>
  
<script>
import regionList from '@/assets/js/region.js'

const dataList = [];
const generateList = data => {
    for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.key;
        dataList.push({ key, title: node.title });
        if (node.children) {
            generateList(node.children);
        }
    }
};
generateList(regionList);

const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.key === key)) {
                parentKey = node.key;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
};

export default {
    name: 'RegionRree',
    props: ['submit'],
    data() {
        return {
            keyword: undefined,
            modal: {
                loading: false,
                show: false,
                data: [],
                title: '选择区域'
            },
            defaultExpandAll: false,
            checkedKeys: [],
            selecttedVals: {
                province_ids: [],
                city_ids: [],
                area_ids: []
            },
            checkTitles: [],
            treeData: regionList,
            autoExpandParent: false,
            expandedKeys: []
        }
    },

    methods: {

        onChange(e) {
            const value = e.target.value;
            const expandedKeys = dataList
                .map(item => {
                    if (item.title.includes(value)) {
                        return getParentKey(item.key, regionList);
                    }
                    return null;
                })
                .filter((item, i, self) => {
                    return item && self.indexOf(item) === i
                });
            Object.assign(this, {
                expandedKeys,
                keyword: value,
                autoExpandParent: true,
            });
            console.log(this.treeData,66)
        },
        onExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
        },
        // searchData(data) {
        //     let filterList = []
        //     data.forEach(val => {
        //         if (val.children) {
        //             let filterArr = this.searchData(val.children)
        //             if (filterArr.length > 0) filterList.push({
        //                 key: val.key,
        //                 title: val.title,
        //                 children: this.searchData(val.children)
        //             })
        //         } else {
        //             if (val.title.includes(this.keyword)) {
        //                 filterList.push({ ...val })
        //             }
        //         }
        //     })
        //     return filterList
        // },
        onCheck(checkedKeys, e) {
            this.checkedKeys = checkedKeys;
            this.checkTitles = e.checkedNodes.map(val => val.data.props.dataRef.title)
            console.log(e)
        },

        confirmmodal() {
            for (let i = 0; i < this.checkedKeys.length; i++) {
                if (this.checkedKeys[i].substring(4, 6) !== '00') {
                    this.selecttedVals.area_ids.push(this.checkedKeys[i])
                } else if (this.checkedKeys[i].substring(2, 4) !== '00') {
                    this.selecttedVals.city_ids.push(this.checkedKeys[i])
                } else if (this.checkedKeys[i].substring(0, 2) !== '10') {
                    this.selecttedVals.province_ids.push(this.checkedKeys[i])
                }

            }
            this.close()
        },
        open(selectedIds) {
            this.checkedKeys = selectedIds
            this.modal.show = true
        },
        close() {
            this.modal.show = false
            this.$emit('submit', this.selecttedVals, this.checkTitles)
        }
    }
}
</script>
  
<style lang="less" scoped>
.checkbox-box {
    height: 36px;
    line-height: 36px;
}

.input-box {
    padding: 10px 3px;

    input {
        border-radius: 15px;
        border: 1px solid #e8e8e8;
        width: 100%;
        height: 36px;
        line-height: 36px;
        padding: 3px 10px;
        outline-style: none;
        transition: 1s;
    }

    input:hover {
        border: 1px solid #cff1f5;
    }

    input:focus {
        border: 2px solid #f5cfcf;
    }


    input::-webkit-input-placeholder {
        /* WebKit browsers，webkit内核浏览器 */
        color: #ccc;
        font-size: 14px;
    }

    input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ccc;
        font-size: 14px;
    }

    input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ccc;
        font-size: 14px;
    }

    input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ccc;
        font-size: 14px;
    }


}
</style>